<template>
    <div class="parking-pay-wrapper">
        <article class="weui-article">
            <section>
                <div
                    class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after weui-cell_plate">
                    <div class="weui-cell__hd"><label class="weui-label">车牌号</label></div>
                    <div class="weui-cell__bd weui-cell__plate" @click="handlePlateOption">{{ checkedPlateName || '无' }}
                    </div>
                    <!-- <div class="main-plate">主车牌: {{ mainPlateName || '无' }}</div> -->
                </div>
            </section>
        </article>
        <article class="weui-article">
            <section>
                <div
                    class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after weui-cell_park">
                    <div class="weui-cell__hd"><label class="weui-label">停车场</label></div>
                    <div class="weui-cell__bd">{{ checkedParkName || '无' }}</div>
                </div>
            </section>
        </article>
        <article class="weui-article">
            <section>
                <div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
                    <div class="weui-cell__hd"><label class="weui-label">收费规则</label></div>
                    <div class="weui-cell__bd" @click="handleFeescaleOption">{{ checkedFeescale || '无' }}</div>
                </div>
            </section>
        </article>
        <article class="weui-article">
            <section>
                <div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
                    <div class="weui-cell__hd"><label class="weui-label">开始日期</label></div>
                    <div class="weui-cell__bd" @click="handleDateOption">{{ checkedDate || '无' }}</div>

                </div>
            </section>
        </article>
        <article class="weui-article" v-if="checkedParkId == 252">
            <section>
                <div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
                    <div class="weui-cell__hd"><label class="weui-label">缴费月数</label></div>
                    <div class="weui-cell__bd" @click="handleMonthOption">{{ checkedMonth || '无' }}</div>
                </div>
            </section>
        </article>
        <article class="weui-article" v-else>
            <section>
                <div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
                    <div class="weui-cell__hd"><label class="weui-label">缴费月数</label></div>
                    <div class="weui-cell__bd" @click="handleMonthOption">{{ checkedMonth || '无' }}</div>
                </div>
            </section>
        </article>
        <div class="weui-article">
            <div class="weui-form-preview__item">
                <br>
                <!-- <label class="weui-form-preview__label">付款金额：</label> -->
                <label class="color weui-cell__hd">付款金额：</label>

                <!-- <label class="weui-form-preview__value">¥{{payMoney}}</label> -->
                <label class="weui-cell__hd">¥{{ payMoney }}</label>
            </div>
        </div>
        <!-- <div class="user-info" v-show="spaceMark"> -->
        <!--<p>楼号: A栋</p>-->
        <!--<p>房间号: 3-101室</p>-->
        <!-- <p>车位号: {{spaceMark}}</p> -->
        <!-- </div> -->
        <div class="weui-btn-area">
            <button class="weui-btn" :class="isDisabled ? 'weui-btn_disabled' : 'weui-btn_primary'" :disabled="isDisabled"
                @click="handlePay">确认缴费</button>
        </div>
    </div>
</template>

<script>
import { getFeescalFixation, getUserSlaveList, payParkingFee } from "../../../../api/coupon/parkingFeetoPay";
import { pay } from "../../../../api/coupon/platePay";
import { mapGetters } from 'vuex'
export default {
    name: "index",
    data() {
        return {
            isOverDue: false,
            plateCount: 0,
            overdue: null,
            endDate: undefined,
            currentDate: undefined,
            dateCount: 0,
            monthCount: 0,
            feescalId: undefined,
            plateinfoId: undefined,
            spaceMark: undefined,
            mainPlateName: undefined,
            checkedPlateName: undefined,
            checkedParkId: undefined,
            checkedFeescale: undefined,
            checkedDate: undefined,
            checkedParkName: undefined,
            checkedPlateOptions: [],
            minMonthCount: undefined,
            checkedMonth: undefined,
            monthsOptions: [],
            checkedMonthOptions: [
                { label: 1, value: 1 },
                { label: 2, value: 2 },
                { label: 3, value: 3 },
                { label: 4, value: 4 },
                { label: 5, value: 5 },
                { label: 6, value: 6 },
                { label: 7, value: 7 },
                { label: 8, value: 8 },
                { label: 9, value: 9 },
                { label: 10, value: 10 },
                { label: 11, value: 11 },
                { label: 12, value: 12 },
            ],
            parkList: [],
            feeMoney: undefined,
            payMoney: 0,
            isDisabled: true,
            feescaleList: []
        }
    },
    computed: {
        ...mapGetters(['userOpenid'])
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        async getInfo() {
            try {
                let plateList = await this.getUserSlaveList();
                console.log(plateList, 'plateList');
                if (plateList.code === 200) {
                    let checkedPlateOptions = plateList.data;
                    // this.plateinfoId=checkedPlateOptions.id
                    console.log(checkedPlateOptions,'checkedPlateOptions');
                    // let parkList = [];
                    // checkedPlateOptions.map(item =>{
                    //     parkList.push({parkName: item.parkName, id:item.parkinglotId})
                    // });
                    // let parkFilterList = parkList.reduce((prev,element) =>{//停车场去重
                    //     if(!prev.find(el => el.id == element.id)) {
                    //         prev.push(element)
                    //     }
                    //     return prev
                    // },[]);
                    // if (parkFilterList.length > 0){
                    //     parkFilterList.map(item =>{
                    // 		this.$set(item,'label',item.parkName)
                    // 	});
                    // 	this.checkedParkId = parkFilterList[0].id;
                    // 	this.checkedParkName = parkFilterList[0].parkName;
                    // }
                    // this.parkList = parkFilterList;
                    this.currentDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, '0')
                        + '-' + new Date().getDate().toString().padStart(2, '0')+" "+ '00:00:00';
                 
                    // checkedPlateOptions[0].overdue = 2

                    console.log(this.currentDate, 'this.currentDate');
                    if (checkedPlateOptions.length > 0) {
                        checkedPlateOptions.map(item => {
                            this.$set(item, 'label', item.slavePlateno + ' ' + item.parkName || item.plateno + ' ' + item.parkName)
                        });
                        this.isOverDue = checkedPlateOptions[0].overdue;
                        this.checkedParkId = checkedPlateOptions[0].parkinglotId;
                        this.checkedParkName = checkedPlateOptions[0].parkName;

                        if (checkedPlateOptions[0].checkedParkId == 252) {
                            this.checkedMonthOptions = [

                                { label: 3, value: 3 },

                                { label: 6, value: 6 },

                                { label: 9, value: 9 },

                                { label: 12, value: 12 },
                            ]
                        }
                        this.plateinfoId = checkedPlateOptions[0].id;
                        this.checkedPlateName = checkedPlateOptions[0].slavePlateno || checkedPlateOptions[0].plateno;
                        this.mainPlateName = checkedPlateOptions[0].plateno;
                        this.spaceMark = checkedPlateOptions[0].spaceMark
                    }
                    this.overdue = checkedPlateOptions[0].overdue
                    
                    if (checkedPlateOptions[0].overdue === 0) {//未过期
                        this.checkedDate = checkedPlateOptions[0].endDate.slice(0, 10);
                       

                        this.endDate = checkedPlateOptions[0].endDate
                    } else {

                        // this.checkedDate = this.currentDate
                        // this.checkedDate = checkedPlateOptions[0].endDate.slice(0, 10)
                        this.endDate = checkedPlateOptions[0].endDate
                        this.checkedDate = this.currentDate

                        // if (this.currentDate > checkedPlateOptions[0].endDate) {
                        // if (time > checkedPlateOptions[0].endDate) {
                        //     this.checkedDate = this.currentDate
                        //     console.log(this.checkedDate, ' this.checkedDate');

                        // } else {
                        //     this.checkedDate = checkedPlateOptions[0].endDate.slice(0, 10)
                        // }

                    }
                    this.checkedPlateOptions = checkedPlateOptions;
                    this.getFeescalFixation()
                }
            } catch (e) {
                this.$weui.alert('浏览器不支持', { title: '提示' })
            }
        },
        getUserSlaveList() {
            return getUserSlaveList({ openid: localStorage.getItem('userOpenId') || this.userOpenid })
        },
        getFeescalFixation() {
            getFeescalFixation({ parkinglotId: this.checkedParkId, platenumber: this.checkedPlateName, plateinfoId:this.plateinfoId }).then(res => {
            // getFeescalFixation({ parkinglotId: this.checkedParkId, platenumber: this.mainPlateName }).then(res => {
                if (res.code === 200) {
                    let feescaleList = res.data;
                    feescaleList.map(item => {
                        this.$set(item, 'label', item.feescalName);
                        this.$set(item, 'value', item.id);
                    });
                    this.feescaleList = feescaleList;
                    if (!this.checkedPlateName || !this.checkedParkId) {
                        this.isDisabled = true
                    } else {
                        this.isDisabled = false
                    }
                    this.feescalId = this.feescaleList[0].id;
                    this.checkedFeescale = this.feescaleList[0].feescalName;
                    this.checkedMonth = this.feescaleList[0].minMonthCount;
                    this.minMonthCount = this.feescaleList[0].minMonthCount;
                    this.feeMoney = this.feescaleList[0].monthAmount;
                    console.log(this.feescaleList[0].monthAmount, 'this.feescaleList[0].monthAmount');
                    this.payMoney = (this.minMonthCount * this.feeMoney).toFixed(2);
                    this.checkedMonthOptions.map(item => {
                        if (item.value < parseInt(this.feescaleList[0].minMonthCount)) {
                            this.$set(item, 'disabled', true)
                        } else {
                            this.$set(item, 'disabled', false)
                        }
                    });

                } else {
                    this.payMoney = this.payMoney.toFixed(2);
                    this.isDisabled = true
                }
            })
        },
        /*点击车牌号选项**/
        handlePlateOption() {
            this.plateCount++;
            this.$weui.picker(this.checkedPlateOptions, {
                onChange: result => {
                    console.log(result[0],'result');
                    this.isOverDue = result[0].overdue;
                    if (result[0].overdue === 0) {
                        this.checkedDate = result[0].endDate.slice(0, 10);
                        this.endDate = result[0].endDate
                    } else {
                        this.checkedDate = this.currentDate
                    }
                    
                    this.checkedPlateName = result[0].slavePlateno || result[0].plateno;
                    this.mainPlateName = result[0].plateno;
                    this.spaceMark = result[0].spaceMark;
                    this.plateinfoId = result[0].id;
                    this.checkedParkId = result[0].parkinglotId;
                    this.checkedParkName = result[0].parkName;
                    this.getFeescalFixation()
                },
                onConfirm: result => {
                    this.isOverDue = result[0].overdue;
                    if (result[0].overdue === 0) {
                        this.checkedDate = result[0].endDate.slice(0, 10);
                        this.endDate = result[0].endDate
                    } else {
                        this.checkedDate = this.currentDate
                    }
                    this.overdue = result[0].overdue;
                    this.checkedPlateName = result[0].slavePlateno || result[0].plateno;
                    this.mainPlateName = result[0].plateno;
                    this.spaceMark = result[0].spaceMark;
                    this.plateinfoId = result[0].id;
                    this.checkedParkId = result[0].parkinglotId;
                    this.checkedParkName = result[0].parkName;
                    this.getFeescalFixation()
                },
                id: this.plateCount,
                title: '车牌号'
            });
        },
        //
        // /*点击停车场选项**/
        // handleParkOption () {
        //     this.$weui.picker(this.parkList, {
        //         onChange: result => {
        //             this.checkedParkId = result[0].id;
        //             this.checkedParkName = result[0].parkName;
        //             this.getFeescalFixation()
        //         },
        //         onConfirm: result => {
        //             this.checkedParkId = result[0].id;
        //             this.checkedParkName = result[0].parkName;
        //             this.getFeescalFixation()
        //         },
        //         title: '停车场'
        //     });
        // },
        /**点击收费规则选项*/
        handleFeescaleOption() {

            this.$weui.picker(this.feescaleList, {
                onChange: result => {
                    this.feescalId = result[0].id;
                    this.checkedFeescale = result[0].feescalName;
                    this.feeMoney = result[0].monthAmount;
                    this.minMonthCount = result[0].minMonthCount;
                    this.payMoney = (this.checkedMonth * this.feeMoney).toFixed(2);
                    this.checkedMonth = result[0].minMonthCount;
                    this.checkedMonthOptions.map(item => {
                        if (item.value < parseInt(result[0].minMonthCount)) {
                            this.$set(item, 'disabled', true)
                        } else {
                            this.$set(item, 'disabled', false)
                        }
                    });
                    this.$forceUpdate()
                },
                onConfirm: result => {
                    this.feescalId = result[0].id;
                    this.checkedFeescale = result[0].feescalName;
                    this.feeMoney = result[0].monthAmount;
                    this.minMonthCount = result[0].minMonthCount;
                    this.payMoney = (this.checkedMonth * this.feeMoney).toFixed(2);
                    this.checkedMonth = result[0].minMonthCount;


                    this.checkedMonthOptions.map(item => {
                        if (item.value < parseInt(result[0].minMonthCount)) {
                            this.$set(item, 'disabled', true)
                        } else {
                            this.$set(item, 'disabled', false)
                        }
                    });
                    this.$forceUpdate()
                },
                defaultValue: [parseInt(this.feescalId)],
                title: '收费规则'
            });
        },
        /**点击开始时间选项*/
        handleDateOption() {
            if (this.isOverDue === 0)
                return;
            this.dateCount++;
            console.log(this.checkedDate, 'this.checkedDate');
            let year = parseInt(this.checkedDate.slice(0, 4));
            let month = parseInt(this.checkedDate.slice(5, 7));
            let day = parseInt(this.checkedDate.slice(8, 11));
            console.log(year, 'year');
            console.log(month, 'month');
            console.log(day, 'day');
            this.$weui.datePicker({
                start: new Date().getFullYear(),
                onChange: result => {
                    console.log(result,'result');
                    if (this.currentDate == undefined) {
                        this.checkedDate = result[0].value + '-' + result[1].value.toString().padStart(2, '0') + '-' +
                            result[2].value.toString().padStart(2, '0');

                    }


                },
                onConfirm: result => {
                    console.log(result,'result');
                    this.checkedDate = result[0].value + '-' + result[1].value.toString().padStart(2, '0') + '-' +
                        result[2].value.toString().padStart(2, '0')
                    console.log(this.checkedDate, ' this.checkedDate2');
                },
                // id: this.dateCount,
                defaultValue: [year, month, day],
                title: '开始时间',
            });
        },
        /*点击月数选项**/
        handleMonthOption() {
            if (!this.checkedParkId) return;
            if (this.checkedParkId == 252|| this.checkedParkId == 13) {
                this.checkedMonthOptions = [

                    { label: 3, value: 3 },

                    { label: 6, value: 6 },

                    { label: 9, value: 9 },

                    { label: 12, value: 12 },
                ]
            }
            this.monthCount++;
            this.$weui.picker(this.checkedMonthOptions, {
                onChange: result => {
                    this.checkedMonth = result[0].value;
                    this.payMoney = (this.checkedMonth * this.feeMoney).toFixed(2)
                },
                onConfirm: result => {
                    this.checkedMonth = result[0].value;
                    this.payMoney = (this.checkedMonth * this.feeMoney).toFixed(2)
                },
                defaultValue: [parseInt(this.checkedMonth)],
                title: '缴费月数',
                id: this.monthCount
            });
        },
        toPayParkingFee() {


         
            let endDate = this.endDate.slice(0, 10);
            let checkedDate = this.checkedDate + ' ' + '00:00:00'
            if (this.overdue != 0) {
                if (this.checkedDate == endDate) {
                   
                    const now = new Date();
                    const hours = now.getHours();
                    const minutes = now.getMinutes();
                    const seconds = now.getSeconds();
                    const time = hours + ":" + minutes + ":" + seconds
                    checkedDate = this.checkedDate + " " + time
              


                }
         

            }

        

            let form = {
                pkFeescalFixationBOListString: [
                    {
                        feescalId: this.feescalId,
                        plateinfoId: this.plateinfoId,
                        platenumber: this.checkedPlateName,
                        months: this.checkedMonth,
                        startDate: this.isOverDue === 1 ? checkedDate : this.endDate,
                        // parkinglotId: this.checkedParkId,
                        payFees: this.payMoney,
                    }
                ],
                isBusinessPlatePay: 0,
                parkinglotId: this.checkedParkId,
                openid: localStorage.getItem('userOpenId') || this.userOpenid
            };
            return payParkingFee(form)
        },
        toPay(orderForm) {
            return pay(orderForm)
        },
        async handlePay() {
            if (this.checkedParkId=='97') {
                this.$weui.alert('莲花广场暂不支持', { title: '提示' })
            }else{
                try {
              
              let payParkingFee = await this.toPayParkingFee();
              if (payParkingFee.code === 200) {
                  console.log();
                  let orderForm = {
                      totalAmount: this.payMoney,
                      parkinglotId: this.checkedParkId,
                      payType: 13,
                      orderSn: payParkingFee.data.orderSn,
                      openId: localStorage.getItem('userOpenId') || this.userOpenid
                  };

                  let order = await this.toPay(orderForm);
                  if (order.code === 200) {
                      this.$pay(order)
                  }
              }
          } catch (e) {
              this.$weui.alert('服务故障', { title: '提示' })
          }
            }
           
        }
    }
}
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable'
	.parking-pay-wrapper{
		padding 20px 0
		.weui-article{
			padding-top 0
			padding-bottom 0
			section{
				margin-bottom 0
			}
			.weui-label{
				width 80px
			}
			.weui-cell__plate{
				flex unset
				width 35%
			}
			.weui-cell__plate:after{
				right 45%
			}
			.weui-cell_select-after{
				padding-left 0
			}
			.main-plate{
				font-size 14px
			}
			.weui-cell_select-after{
				display flex
				/*justify-content space-between*/
			}
			.weui-cell_park{
				.weui-cell__bd:after{
					width 0
					height: 0;
				}
			}
		}
		.user-info{
			font-size 16px
			color #6d6d6d
			padding 10px 15px
			display flex
			/*justify-content space-around*/
		}
		.weui-btn-area{
			margin-top 50px
			.weui-btn_primary, .weui-btn_disabled{
				width 100%
			}
		}
	}
.weui-form-preview__item{
    display: flex;
    margin-top:20px
}
.color{
    color: #8b8080;
}

</style>
